import React from 'react';
import clsx from 'clsx';

/**
 * Tailwind CSS version of BaseText and convenience text components.
 */

const fontWeights = {
  extralight: 'font-extralight',
  light: 'font-light',
  regular: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
  extrabold: 'font-extrabold',
};

export const BaseText = ({
  children,
  weight = 'regular',
  color = 'text-gray-900',
  margin,
  lineHeight,
  textDecoration = 'none',
  fontSize = 'text-base',
  className = '',
  as: Component = 'p',
  fontFamily = 'font-duplet',
}) => {
  const classes = clsx(
    fontWeights[weight],
    fontSize,
    fontFamily,
    color,
    {
      underline: textDecoration === 'underline',
      'line-through': textDecoration === 'line-through',
      'no-underline': textDecoration === 'none',
    },
    margin,
    lineHeight,
    'py-0.5', // padding top & bottom
    className
  );

  return <Component className={classes}>{children}</Component>;
};

//  Convenience components
export const LightText = (props) => <BaseText {...props} weight="light" />;
export const RegularText = (props) => (
  <BaseText {...props} weight="regular" fontSize="text-sm" />
);
export const MediumText = (props) => <BaseText {...props} weight="medium" />;
export const SemiBoldText = (props) => (
  <BaseText {...props} weight="semibold" fontSize="text-2xl" />
);
export const BoldText = (props) => <BaseText {...props} weight="bold" />;
export const ExtraBoldText = (props) => (
  <BaseText {...props} weight="extrabold" />
);
export const ExtraLightText = (props) => (
  <BaseText {...props} weight="extralight" />
);
